const assignment = {
  id: null,
  userId: null,
  billRate: null,
  startAt: null,
  endAt: null,
  contractTypeId: null,
  lengthOfContract: null,
  conversionFee: null,
  employeeTypeId: null,
  corporateName: null,
  active: null,
  clientId: null,
  overtimeEligible: null,
  billRateTypeId: null,
  payFrequencyId: null,
  payRateTypeId: null,
  payRate: null,
  ein: null,
  commissions: [],
  expenses: [],
  defaultExpensesByClient: [],
  expensesDeduction: 0,
  vmsFee: null,
  workedHoursAverage: null,
  jobTitle: null,
  timeSheetType: 2,
  clockIPAddress: null,
  overtimeThreshold: null,
  overtimeRate: null
}

export default () => Object.assign({}, assignment)
